import { cn } from '@/lib/utils'

const FALLBACK_IMAGE = 'https://via.placeholder.com/200?text=No+Image'

interface ProductImageProps {
    src: string | null | undefined
    alt: string
    className?: string
    fallback?: string
}

/**
 * Reusable product image component with built-in error handling.
 * Displays a fallback placeholder when the image fails to load or is null.
 */
export function ProductImage({
    src,
    alt,
    className,
    fallback = FALLBACK_IMAGE
}: ProductImageProps) {
    return (
        <img
            src={src || fallback}
            alt={alt}
            className={cn('object-cover', className)}
            onError={(e) => {
                const target = e.target as HTMLImageElement
                if (target.src !== fallback) {
                    target.src = fallback
                }
            }}
        />
    )
}

